import { getEntityQueryOptions } from '@/queries/getEntityQueryOptions';
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/$module_id/$entity_type_id/$entity_id/',
)({
  beforeLoad: async ({ params, context: { queryClient } }) => {

    const { entity_type_id, entity_id } = params;
    const data = await queryClient.ensureQueryData(getEntityQueryOptions(entity_type_id, entity_id));

    if (!data?.view?.primaryTabs) {
      throw redirect({ to: '/$module_id/$entity_type_id/$entity_id/details', params, replace: true });
    }


    if (data?.view?.primaryTabs[0].collection === 'overview') {
      throw redirect({ to: '/$module_id/$entity_type_id/$entity_id/overview', params, replace: true });
    }

    if (data?.view?.primaryTabs[0].collection === 'view-report') {
      throw redirect({ to: '/$module_id/$entity_type_id/$entity_id/view-report', params, replace: true });
    }

    if (data?.view?.primaryTabs.length > 0) {
      throw redirect({
        to: '/$module_id/$entity_type_id/$entity_id/$subCollection',
        params: { ...params, subCollection: data?.view?.primaryTabs[0].collection as string },
        replace: true
      });
    }

  },
})

